// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__ZMPAr","item":"style_item__ZXsCY","itemActive":"style_itemActive__IRKrk"};